import axios from 'axios'
import { Auth } from 'aws-amplify'
export const REACT_APP_URL = window.location.origin

const REGION = 'us-east-2'
const USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID
const APP_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID
const IDENTITY_POOL_ID = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
const COGNITO_DOMAIN = `${process.env.REACT_APP_STAGE}-syn-auth.auth.us-east-2.amazoncognito.com`
const COGNITO_SIGNIN_CALLBACK = `${REACT_APP_URL}/login`
const COGNITO_SIGNOUT_CALLBACK = `${REACT_APP_URL}/login`
export const ADMIN_CONTACT = 'Support@agconnections.com'

const scope = [
  'phone',
  'email',
  'profile',
  'openid'
]

export const loginInfo = {
  errorContact : ADMIN_CONTACT,
  STAGE : process.env.REACT_APP_STAGE,
  API_URL: process.env.REACT_APP_API_URL,
  REGION,
  USER_POOL_ID,
  APP_CLIENT_ID,
  IDENTITY_POOL_ID,
  COGNITO_DOMAIN,
  COGNITO_SIGNIN_CALLBACK,
  COGNITO_SIGNOUT_CALLBACK,
  scope
}

axios.interceptors.request.use(async config => {
  config.headers['x-api-key'] = '0'
  config.headers['Content-Type'] = 'application/json'
  return new Promise(resolve => {
    Auth.currentSession()
      .then(session => {
        if(session){
          const idTokenExpire = session.getIdToken().getExpiration()
          const refreshToken = session.getRefreshToken()
          const currentTimeSeconds = Math.round(+new Date() / 1000)
          const remainingTime = (idTokenExpire - currentTimeSeconds) / 60
          if (remainingTime < 55) {
            Auth.currentAuthenticatedUser()
              .then(cognitoUser => {
                if(cognitoUser?.refreshSession){
                  cognitoUser.refreshSession(refreshToken, (err, data) => {
                    if (err) {
                      console.error('AUTH error: ', err)
                      Auth.signOut()
                    } else {
                      config.headers['x-user-token'] = data.accessToken.jwtToken
                      return resolve(config)
                    }
                  })
                }
              })
          } else {
            config.headers['x-user-token'] = session.accessToken.jwtToken
            return resolve(config)
          }
        } else {
          return resolve(config)
        }
      })
      .catch(err => {
        const accessToken = window.sessionStorage.getItem('accessToken')
        if(accessToken){
          config.headers['x-user-token'] = accessToken
        } else {
          console.error('FAILED SESSION: ', err)
        }
        return resolve(config)
      })
  })
})

export const authConfig = {
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  region: REGION,
  userPoolId: USER_POOL_ID,
  identityPoolId: IDENTITY_POOL_ID,
  userPoolWebClientId: APP_CLIENT_ID,
  oauth: {
    domain: COGNITO_DOMAIN,
    scope,
    redirectSignIn: COGNITO_SIGNIN_CALLBACK,
    redirectSignOut: COGNITO_SIGNOUT_CALLBACK,
    responseType: 'code'
  }
}

export const testSession = async (resolve, reject) => {
  try {
    const session = await Auth.currentSession()
    if(resolve){
      resolve(session)
    }
  }
  catch(e) {
    console.error('AUTHCONFIG: FAILED TO LOAD SESSION: ', e)
    if(reject){
      reject()
    }
  }
}
